import { c as _c } from "react/compiler-runtime";
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import React, { type ReactNode } from 'react';
type ErrorHelperProps = {
  error: unknown;
  questionId?: string;
};
const stripValidationPrefix = (string: string) => string.replace(/^\s*ValidationError:\s*/i, '');
const isReactElement = (value: unknown): value is React.ReactElement => {
  return React.isValidElement(value);
};
const isString = (value: unknown): value is string => {
  return typeof value === 'string';
};
const isErrorInstance = (value: unknown): value is Error => {
  return value instanceof Error;
};
const hasIssuesArray = (value: unknown): value is {
  issues: unknown;
} => {
  return typeof value === 'object' && value !== null && 'issues' in value;
};
const hasErrorsArray = (value: unknown): value is {
  errors: unknown;
} => {
  return typeof value === 'object' && value !== null && 'errors' in value;
};
const extractErrorMessage = (error: unknown): ReactNode => {
  if (isReactElement(error)) return error;
  if (isString(error)) return stripValidationPrefix(error);
  if (isErrorInstance(error) && typeof error.message === 'string') return stripValidationPrefix(error.message);
  if (hasIssuesArray(error)) {
    const maybeIssues = (error as {
      issues?: unknown;
    }).issues;
    if (Array.isArray(maybeIssues) && maybeIssues.length > 0) {
      const first = maybeIssues[0] as {
        message?: unknown;
      };
      if (typeof first?.message === 'string') {
        return stripValidationPrefix(first.message);
      }
      return String(first);
    }
  }
  if (hasErrorsArray(error)) {
    const maybeErrors = (error as {
      errors?: unknown;
    }).errors;
    if (Array.isArray(maybeErrors) && maybeErrors.length > 0 && typeof maybeErrors[0] === 'string') {
      return stripValidationPrefix(maybeErrors[0] as string);
    }
  }
  if (typeof error === 'object' && error !== null) {
    return stripValidationPrefix(JSON.stringify(error));
  }
  return String(error ?? '');
};
export const ErrorHelper = t0 => {
  const $ = _c(9);
  const {
    error,
    questionId
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = extractErrorMessage(error);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  const t2 = questionId ?? "";
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="flex items-center gap-2 p-2"><FontAwesomeIcon icon={faCircleExclamation} />{t("error", {
        ns: "common"
      })}</p>;
    t4 = <div className="bg-primary h-px" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== content) {
    t5 = <p className="p-2">{content}</p>;
    $[4] = content;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = <div data-error-id={t2} className="border-primary text-primary rounded-lg border">{t3}{t4}{t5}</div>;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};